import React from "react";
import { useLanguage } from "../Language";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import "./ContactForm.css";

function ContactForm() {
  const { t, language } = useLanguage();
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const packageNames = {
    starter: "Starter",
    advanced: "Advanced",
    individual: "Individual",
  };
  const selectedPackage = packageNames[params.get("p")];
  const clearPackage = (event) => {
    const next = new URLSearchParams(params);
    next.delete("p");
    event.currentTarget.form.elements
      .namedItem("name")
      .focus({ preventScroll: true });
    navigate(
      { search: next.toString(), hash: location.hash },
      { replace: true, state: { preserveScroll: true } },
    );
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const fields = new FormData(event.currentTarget);
    const subject = `${language === "de" ? "Kontaktanfrage von" : "Enquiry from"} ${fields.get("name")}${selectedPackage ? ` (${selectedPackage})` : ""}`;
    const body = `${fields.get("message")}\n\n${fields.get("name")}\n${fields.get("email")}`;
    window.open(
      `mailto:info@quicr.eu?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`,
      "_blank",
      "noopener,noreferrer",
    );
  };
  return (
    <section
      id="contact"
      className="contact-section"
      aria-labelledby="contact-title"
    >
      <div className="contact-layout page-width">
        <div className="contact-intro">
          <h2 id="contact-title" className="contact-heading" tabIndex={-1}>
            {t("Bringen wir euren Ort in Bewegung.")}
          </h2>
          <p>{t("Erzählt uns von eurem Ort und eurer Idee.")}</p>
          <a className="text-link" href="mailto:info@quicr.eu">
            info@quicr.eu
          </a>
        </div>
        <form
          className="contact-form"
          aria-label={t("Kontakt")}
          onSubmit={handleSubmit}
        >
          {selectedPackage && (
            <p className="contact-package">
              <span>{t("Anfrage zu")}</span> <span>{selectedPackage}</span>
              <button
                type="button"
                className="contact-package-clear"
                aria-label={t("Paket entfernen")}
                onClick={clearPackage}
              >
                {t("Entfernen")}
              </button>
            </p>
          )}
          <label htmlFor="contact-name">{t("Name")}</label>
          <input
            id="contact-name"
            name="name"
            autoComplete="name"
            placeholder={t("Euer Name")}
            required
          />
          <label htmlFor="contact-email">{t("E-Mail")}</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="name@example.com"
            required
          />
          <label htmlFor="contact-message">{t("Nachricht")}</label>
          <textarea
            id="contact-message"
            name="message"
            placeholder={t("Was möchtet ihr in Bewegung bringen?")}
            required
            minLength={25}
            aria-describedby="message-hint"
          />
          <small id="message-hint">{t("Mindestens 25 Zeichen.")}</small>
          <button type="submit" className="action action-primary">
            {t("E-Mail vorbereiten")}
          </button>
          <p className="contact-email-note">
            {t(
              "Öffnet euer E-Mail-Programm. Die Nachricht wird dort von euch versendet.",
            )}
          </p>
        </form>
      </div>
    </section>
  );
}
export default ContactForm;
